// material-ui
import { DataGrid } from '../../components/grid/DataGrid';
import { Button, Box, Typography } from '@mui/material';
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton
} from '@mui/x-data-grid-pro';

import {
  Launch,
  AssessmentOutlined,
  AccountBalanceOutlined,
  SettingsOutlined,
  DescriptionOutlined,
  BarChartOutlined,
  TrendingUpOutlined
} from '@mui/icons-material';

// project import
import MainLayout from '../../layout/MainLayout';
import { useSelector, useDispatch } from 'react-redux';
import React, { useState } from 'react';
import {
  actions as routeActions,
  types as routes
} from '../../reducers/rotas.actions';
import MainCard from '../../components/MainCard';
import { columns as columnsOportunidade } from './Columns';
import {
  salvarFiltrosGrid,
  setPaginationModel,
  setSortModel
} from 'reducers/oportunidade.reducer';
import { toast } from 'react-toastify';
import {
  Card,
  Grid,
  Skeleton
} from '../../../node_modules/@mui/material/index';
import formatters from 'utils/formatters';

const ICONES_ETAPA = {
  Simulação: AssessmentOutlined,
  Crédito: AccountBalanceOutlined,
  Engenharia: SettingsOutlined,
  'Contrato Emitido': DescriptionOutlined
};
const getIconeEtapa = (nomeEtapa) =>
  ICONES_ETAPA[nomeEtapa] ?? TrendingUpOutlined;

const StatCard = ({ label, Icon, primary, secondary }) => (
  <Card
    sx={{
      padding: '20px',
      marginBottom: '5px',
      height: '100%'
    }}
  >
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '18px',
        gap: 1
      }}
    >
      <Typography
        component="div"
        sx={{
          fontSize: '0.85rem',
          fontWeight: 500,
          color: 'text.secondary',
          lineHeight: 1.3,
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}
      >
        {label}
      </Typography>
      {Icon && (
        <Icon
          sx={{
            color: 'text.secondary',
            fontSize: '1.15rem',
            flexShrink: 0
          }}
        />
      )}
    </Box>
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        gap: 1
      }}
    >
      <Typography
        component="div"
        sx={{
          fontSize: '1.9rem',
          fontWeight: 800,
          lineHeight: 1,
          fontVariantNumeric: 'tabular-nums',
          letterSpacing: '-0.025em'
        }}
      >
        {primary}
      </Typography>
      <Typography
        component="div"
        sx={{
          fontSize: '1.05rem',
          fontWeight: 700,
          fontVariantNumeric: 'tabular-nums',
          letterSpacing: '-0.01em',
          whiteSpace: 'nowrap'
        }}
      >
        {secondary}
      </Typography>
    </Box>
  </Card>
);

const OportunidadesPage = () => {
  const temperatura = useSelector((state) => state.dominios.temperatura);
  const parceiros = useSelector((state) => state.dominios.parceiro);
  const regionais = useSelector((state) => state.dominios.regional);
  const usuariosParceiros = useSelector(
    (state) => state.dominios.usuarioParceiro
  );
  const usuarios = useSelector((state) => state.dominios.usuario);
  const bancos = useSelector((state) => state.dominios.listarBancos.data);
  const operacoes = useSelector((state) => state.dominios.operacao);
  const etapas = useSelector((state) => state.dominios.etapa);
  const oportunidades = useSelector(
    (state) => state.oportunidade.oportunidades
  );
  const usuario = useSelector((state) => state.usuario);
  const rows = oportunidades.data.map((i) => {
    return {
      ...i,
      id: i.idOportunidade,
      dataOportunidade: new Date(`${i.dataOportunidade}T00:00:00`),
      dataPrevistaEmissaoContrato: i.dataPrevistaEmissaoContrato
        ? new Date(`${i.dataPrevistaEmissaoContrato}T00:00:00`)
        : ''
    };
  });

  const filtrosGrid = useSelector((state) => state.oportunidade.filtrosGrid);
  const paginationModel = useSelector(
    (state) => state.oportunidade.paginationModel
  );
  const sortModel = useSelector((state) => state.oportunidade.sortModel);
  const totalRegistros = oportunidades.total ?? 0;
  const valorTotalFinanciamento = oportunidades.valorTotalFinanciamento ?? 0;

  const funilDeVendas = useSelector(
    (state) => state.oportunidade.funilDeVendas.data
  );

  const loading = useSelector(
    (state) => state.oportunidade.funilDeVendas.loading
  );

  const dispatch = useDispatch();

  const columns = columnsOportunidade({
    operacoes,
    temperatura,
    regionais,
    parceiros,
    usuariosParceiros,
    usuarios,
    bancos,
    etapas,
    usuario
  });

  const handleRowClick = (params) => {
    const { idOportunidade } = params;
    dispatch(
      routeActions.redirectTo(routes.OPORTUNIDADE, { id: idOportunidade })
    );
  };

  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
    regional: false,
    usuarioParceiro: false,
    consultor: false,
    analista: false,
    cpfCnpj: false,
    atividades: false,
    etapa: false
  });

  const CustomToolbar = ({ apiRef }) => {
    const selectedRows = apiRef.current.getSelectedRows();

    const handleButtonClick = () => {
      if (selectedRows.size === 0) {
        toast.error('Selecione pelo menos uma linha.');
      } else {
        const selectedRowData = Array.from(selectedRows.values());
        handleRowClick(selectedRowData[0]);
      }
    };

    // const handleFunilDeVendas = () => {
    //   let filteredDataRowIDs = [];
    //   if (apiRef.current?.state?.filter?.filteredRowsLookup) {
    //     filteredDataRowIDs = Object.entries(
    //       apiRef.current.state.filter.filteredRowsLookup
    //     )
    //       .filter(([_, value]) => value === true)
    //       .map(([key, _]) => Number(key));
    //   }
    //   dispatch(routesActions.redirectTo(routes.FUNIL_DE_VENDAS));
    //   dispatch(obterFunilDeVendasRequest({ value: filteredDataRowIDs }));
    // };

    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarExport
          csvOptions={{
            includeHeaders: true,
            allColumns: true,
            utf8WithBom: true
          }}
        />
        <>
          <Button
            variant="text"
            color="primary"
            disabled={selectedRows.size !== 1}
            onClick={handleButtonClick}
            startIcon={<Launch />}
            sx={{
              maxHeight: 30.75,
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingLeft: '5px',
              paddingRight: '5px'
            }}
          >
            Acessar Oportunidade
          </Button>
          {/* <Button
                variant="text"
                color="primary"
                onClick={handleFunilDeVendas}
                startIcon={<FilterOutlined />}
                disabled={loading}
                sx={{
                  maxHeight: 30.75,
                  paddingTop: '4px',
                  paddingBottom: '4px',
                  paddingLeft: '5px',
                  paddingRight: '5px'
                }}
              >
                Funil de Vendas
              </Button> */}
        </>
      </GridToolbarContainer>
    );
  };

  return (
    <MainLayout>
      <MainCard
        title="Oportunidades"
        border={false}
        sx={{ paddingBottom: '0px' }}
      >
        <Grid container spacing={2}>
          {loading &&
            [...Array(5)].map((_, index) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={true}
                key={`skeleton-${index}`}
              >
                <Card
                  sx={{
                    padding: '20px',
                    marginBottom: '5px',
                    height: '100%'
                  }}
                >
                  <Skeleton variant="text" height={20} sx={{ mb: 2 }} />
                  <Skeleton variant="rectangular" height={36} />
                </Card>
              </Grid>
            ))}

          {!loading &&
            funilDeVendas.map((item, index) => {
              const Icone = getIconeEtapa(item.nomeEtapa);
              return (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={true}
                  key={item.idEtapa ?? index}
                >
                  <StatCard
                    label={item.nomeEtapa}
                    Icon={Icone}
                    primary={item.quantidadeOportunidades}
                    secondary={formatters.numbers.simpleCurrency(
                      item.valorTotalFinanciado
                    )}
                  />
                </Grid>
              );
            })}

          {!loading && (
            <Grid item xs={12} sm={6} md={4} lg={true}>
              <StatCard
                label="Total de Oportunidades"
                Icon={BarChartOutlined}
                primary={totalRegistros.toLocaleString('pt-BR')}
                secondary={formatters.numbers.simpleCurrency(
                  valorTotalFinanciamento
                )}
              />
            </Grid>
          )}
        </Grid>

        <Box sx={{ marginTop: '10px' }}>
          <DataGrid
            filterMode="server"
            paginationMode="server"
            sortingMode="server"
            rowCount={totalRegistros}
            paginationModel={paginationModel}
            onPaginationModelChange={(model) =>
              dispatch(setPaginationModel(model))
            }
            sortModel={sortModel}
            onSortModelChange={(model) => dispatch(setSortModel(model))}
            filterModel={filtrosGrid}
            onFilterModelChange={(filter) => dispatch(salvarFiltrosGrid(filter))}
            rows={rows}
            columns={columns}
            pageSizeOptions={[10, 25, 50, 100]}
            loading={oportunidades.loading}
            handleRowClick={handleRowClick}
            isOportunidade={true}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
            noLineText="Nenhuma oportunidade encontrada"
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10
                }
              },
              density: 'standard'
            }}
            toolbar={CustomToolbar}
          />
        </Box>
      </MainCard>
    </MainLayout>
  );
};

export default OportunidadesPage;
